/**
 * Copyright IBM Corp. 2016, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { i as iconPropTypes, _ as _objectWithoutProperties, I as Icon, a as _objectSpread2 } from '../iconPropTypes-44033017.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _path18, _path19, _path20, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path21, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _path22, _path23, _path24, _path25, _circle28, _path26, _path27, _path28, _circle29, _path29, _circle30, _path30, _circle31, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _circle32, _circle33, _circle34, _path40, _circle35, _path41, _circle36, _circle37, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _circle38, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _circle39, _path106, _path107, _circle40, _path108, _path109, _circle41, _circle42, _circle43, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _circle50, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189;

var _excluded = ["children", "size"],
    _excluded2 = ["children", "size"],
    _excluded3 = ["children", "size"],
    _excluded4 = ["children", "size"],
    _excluded5 = ["children", "size"],
    _excluded6 = ["children", "size"],
    _excluded7 = ["children", "size"],
    _excluded8 = ["children", "size"],
    _excluded9 = ["children", "size"],
    _excluded10 = ["children", "size"],
    _excluded11 = ["children", "size"],
    _excluded12 = ["children", "size"],
    _excluded13 = ["children", "size"],
    _excluded14 = ["children", "size"],
    _excluded15 = ["children", "size"],
    _excluded16 = ["children", "size"],
    _excluded17 = ["children", "size"],
    _excluded18 = ["children", "size"],
    _excluded19 = ["children", "size"],
    _excluded20 = ["children", "size"],
    _excluded21 = ["children", "size"],
    _excluded22 = ["children", "size"],
    _excluded23 = ["children", "size"],
    _excluded24 = ["children", "size"],
    _excluded25 = ["children", "size"],
    _excluded26 = ["children", "size"],
    _excluded27 = ["children", "size"],
    _excluded28 = ["children", "size"],
    _excluded29 = ["children", "size"],
    _excluded30 = ["children", "size"],
    _excluded31 = ["children", "size"],
    _excluded32 = ["children", "size"],
    _excluded33 = ["children", "size"],
    _excluded34 = ["children", "size"],
    _excluded35 = ["children", "size"],
    _excluded36 = ["children", "size"],
    _excluded37 = ["children", "size"],
    _excluded38 = ["children", "size"],
    _excluded39 = ["children", "size"],
    _excluded40 = ["children", "size"],
    _excluded41 = ["children", "size"],
    _excluded42 = ["children", "size"],
    _excluded43 = ["children", "size"],
    _excluded44 = ["children", "size"],
    _excluded45 = ["children", "size"],
    _excluded46 = ["children", "size"],
    _excluded47 = ["children", "size"],
    _excluded48 = ["children", "size"],
    _excluded49 = ["children", "size"],
    _excluded50 = ["children", "size"],
    _excluded51 = ["children", "size"],
    _excluded52 = ["children", "size"],
    _excluded53 = ["children", "size"],
    _excluded54 = ["children", "size"],
    _excluded55 = ["children", "size"],
    _excluded56 = ["children", "size"],
    _excluded57 = ["children", "size"],
    _excluded58 = ["children", "size"],
    _excluded59 = ["children", "size"],
    _excluded60 = ["children", "size"],
    _excluded61 = ["children", "size"],
    _excluded62 = ["children", "size"],
    _excluded63 = ["children", "size"],
    _excluded64 = ["children", "size"],
    _excluded65 = ["children", "size"],
    _excluded66 = ["children", "size"],
    _excluded67 = ["children", "size"],
    _excluded68 = ["children", "size"],
    _excluded69 = ["children", "size"],
    _excluded70 = ["children", "size"],
    _excluded71 = ["children", "size"],
    _excluded72 = ["children", "size"],
    _excluded73 = ["children", "size"],
    _excluded74 = ["children", "size"],
    _excluded75 = ["children", "size"],
    _excluded76 = ["children", "size"],
    _excluded77 = ["children", "size"],
    _excluded78 = ["children", "size"],
    _excluded79 = ["children", "size"],
    _excluded80 = ["children", "size"],
    _excluded81 = ["children", "size"],
    _excluded82 = ["children", "size"],
    _excluded83 = ["children", "size"],
    _excluded84 = ["children", "size"],
    _excluded85 = ["children", "size"],
    _excluded86 = ["children", "size"],
    _excluded87 = ["children", "size"],
    _excluded88 = ["children", "size"],
    _excluded89 = ["children", "size"],
    _excluded90 = ["children", "size"],
    _excluded91 = ["children", "size"],
    _excluded92 = ["children", "size"],
    _excluded93 = ["children", "size"],
    _excluded94 = ["children", "size"],
    _excluded95 = ["children", "size"],
    _excluded96 = ["children", "size"],
    _excluded97 = ["children", "size"],
    _excluded98 = ["children", "size"],
    _excluded99 = ["children", "size"],
    _excluded100 = ["children", "size"],
    _excluded101 = ["children", "size"],
    _excluded102 = ["children", "size"],
    _excluded103 = ["children", "size"],
    _excluded104 = ["children", "size"],
    _excluded105 = ["children", "size"],
    _excluded106 = ["children", "size"],
    _excluded107 = ["children", "size"],
    _excluded108 = ["children", "size"],
    _excluded109 = ["children", "size"],
    _excluded110 = ["children", "size"],
    _excluded111 = ["children", "size"],
    _excluded112 = ["children", "size"],
    _excluded113 = ["children", "size"],
    _excluded114 = ["children", "size"],
    _excluded115 = ["children", "size"],
    _excluded116 = ["children", "size"],
    _excluded117 = ["children", "size"],
    _excluded118 = ["children", "size"],
    _excluded119 = ["children", "size"],
    _excluded120 = ["children", "size"],
    _excluded121 = ["children", "size"],
    _excluded122 = ["children", "size"],
    _excluded123 = ["children", "size"],
    _excluded124 = ["children", "size"],
    _excluded125 = ["children", "size"];
var Movement = /*#__PURE__*/React.forwardRef(function Movement(_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Movement.propTypes = iconPropTypes;
}
var Mp3 = /*#__PURE__*/React.forwardRef(function Mp3(_ref2, ref) {
  var children = _ref2.children,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 16 : _ref2$size,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9H22v2h6v4H24v2h4v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Mp3.propTypes = iconPropTypes;
}
var Mp4 = /*#__PURE__*/React.forwardRef(function Mp4(_ref3, ref) {
  var children = _ref3.children,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 16 : _ref3$size,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 9L6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Mp4.propTypes = iconPropTypes;
}
var Mpeg = /*#__PURE__*/React.forwardRef(function Mpeg(_ref4, ref) {
  var children = _ref4.children,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 16 : _ref4$size,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21H28a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H28v6h2V17H29l0-2h3zM24 13L24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Mpeg.propTypes = iconPropTypes;
}
var Mpg2 = /*#__PURE__*/React.forwardRef(function Mpg2(_ref5, ref) {
  var children = _ref5.children,
      _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 16 : _ref5$size,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21H26V17a2.002 2.002 0 012-2h2V13H26V11h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H28v2h4zM24 21H20a2.0023 2.0023 0 01-2-2V13a2.002 2.002 0 012-2h4v2H20v6h2V17H21l0-2h3zM14 11H9V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0014 11zm-3 5V13h3l.001 3zM7 11L5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Mpg2.propTypes = iconPropTypes;
}
var Music = /*#__PURE__*/React.forwardRef(function Music(_ref6, ref) {
  var children = _ref6.children,
      _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 16 : _ref6$size,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Music.propTypes = iconPropTypes;
}
var MusicAdd = /*#__PURE__*/React.forwardRef(function MusicAdd(_ref7, ref) {
  var children = _ref7.children,
      _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 16 : _ref7$size,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  MusicAdd.propTypes = iconPropTypes;
}
var MusicRemove = /*#__PURE__*/React.forwardRef(function MusicRemove(_ref8, ref) {
  var children = _ref8.children,
      _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? 16 : _ref8$size,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.41 7L30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7zM24 15v7.5562A3.9552 3.9552 0 0022 22a4 4 0 104 4V15zM22 28a2 2 0 112-2A2.0027 2.0027 0 0122 28zM17 6H10A2.002 2.002 0 008 8V22.5562A3.9557 3.9557 0 006 22a4 4 0 104 4V8h7zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  MusicRemove.propTypes = iconPropTypes;
}
var NameSpace = /*#__PURE__*/React.forwardRef(function NameSpace(_ref9, ref) {
  var children = _ref9.children,
      _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? 16 : _ref9$size,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4H7V6H4v4H7zM9 10H15V12H9zM17 10H23V12H17zM28 12H25V10h3V6H25V4h3a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 12zM17 4H23V6H17zM9 4H15V6H9zM28 28H4a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 28zM4 22v4H28V22zM2 15H30V17H2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NameSpace.propTypes = iconPropTypes;
}
var NavaidCivil = /*#__PURE__*/React.forwardRef(function NavaidCivil(_ref10, ref) {
  var children = _ref10.children,
      _ref10$size = _ref10.size,
      size = _ref10$size === void 0 ? 16 : _ref10$size,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidCivil.propTypes = iconPropTypes;
}
var NavaidDme = /*#__PURE__*/React.forwardRef(function NavaidDme(_ref11, ref) {
  var children = _ref11.children,
      _ref11$size = _ref11.size,
      size = _ref11$size === void 0 ? 16 : _ref11$size,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidDme.propTypes = iconPropTypes;
}
var NavaidHelipad = /*#__PURE__*/React.forwardRef(function NavaidHelipad(_ref12, ref) {
  var children = _ref12.children,
      _ref12$size = _ref12.size,
      size = _ref12$size === void 0 ? 16 : _ref12$size,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidHelipad.propTypes = iconPropTypes;
}
var NavaidMilitary = /*#__PURE__*/React.forwardRef(function NavaidMilitary(_ref13, ref) {
  var children = _ref13.children,
      _ref13$size = _ref13.size,
      size = _ref13$size === void 0 ? 16 : _ref13$size,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidMilitary.propTypes = iconPropTypes;
}
var NavaidMilitaryCivil = /*#__PURE__*/React.forwardRef(function NavaidMilitaryCivil(_ref14, ref) {
  var children = _ref14.children,
      _ref14$size = _ref14.size,
      size = _ref14$size === void 0 ? 16 : _ref14$size,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidMilitaryCivil.propTypes = iconPropTypes;
}
var NavaidNdb = /*#__PURE__*/React.forwardRef(function NavaidNdb(_ref15, ref) {
  var children = _ref15.children,
      _ref15$size = _ref15.size,
      size = _ref15$size === void 0 ? 16 : _ref15$size,
      rest = _objectWithoutProperties(_ref15, _excluded15);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "4",
    r: "2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "28",
    r: "2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "16",
    r: "2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "7.515",
    r: "2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "24.485",
    r: "2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "7.515",
    r: "2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "24.485",
    r: "2"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidNdb.propTypes = iconPropTypes;
}
var NavaidNdbDme = /*#__PURE__*/React.forwardRef(function NavaidNdbDme(_ref16, ref) {
  var children = _ref16.children,
      _ref16$size = _ref16.size,
      size = _ref16$size === void 0 ? 16 : _ref16$size,
      rest = _objectWithoutProperties(_ref16, _excluded16);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H2V4A2.0021 2.0021 0 014 2h8V4H4zM12 30H4a2.0021 2.0021 0 01-2-2V20H4v8h8zM28 30H20V28h8V20h2v8A2.0021 2.0021 0 0128 30zM30 12H28V4H20V2h8a2.0021 2.0021 0 012 2zM16 22a6 6 0 116-6A6.0067 6.0067 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "7",
    r: "1"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "1"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "29",
    r: "1"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "16",
    r: "1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "16",
    r: "1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "16",
    r: "1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "16",
    r: "1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "9.636",
    r: "1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "22.364",
    r: "1"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "1"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "9.636",
    r: "1"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "7",
    r: "1"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "22.364",
    r: "1"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidNdbDme.propTypes = iconPropTypes;
}
var NavaidPrivate = /*#__PURE__*/React.forwardRef(function NavaidPrivate(_ref17, ref) {
  var children = _ref17.children,
      _ref17$size = _ref17.size,
      size = _ref17$size === void 0 ? 16 : _ref17$size,
      rest = _objectWithoutProperties(_ref17, _excluded17);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidPrivate.propTypes = iconPropTypes;
}
var NavaidSeaplane = /*#__PURE__*/React.forwardRef(function NavaidSeaplane(_ref18, ref) {
  var children = _ref18.children,
      _ref18$size = _ref18.size,
      size = _ref18$size === void 0 ? 16 : _ref18$size,
      rest = _objectWithoutProperties(_ref18, _excluded18);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidSeaplane.propTypes = iconPropTypes;
}
var NavaidTacan = /*#__PURE__*/React.forwardRef(function NavaidTacan(_ref19, ref) {
  var children = _ref19.children,
      _ref19$size = _ref19.size,
      size = _ref19$size === void 0 ? 16 : _ref19$size,
      rest = _objectWithoutProperties(_ref19, _excluded19);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidTacan.propTypes = iconPropTypes;
}
var NavaidVhfor = /*#__PURE__*/React.forwardRef(function NavaidVhfor(_ref20, ref) {
  var children = _ref20.children,
      _ref20$size = _ref20.size,
      size = _ref20$size === void 0 ? 16 : _ref20$size,
      rest = _objectWithoutProperties(_ref20, _excluded20);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidVhfor.propTypes = iconPropTypes;
}
var NavaidVor = /*#__PURE__*/React.forwardRef(function NavaidVor(_ref21, ref) {
  var children = _ref21.children,
      _ref21$size = _ref21.size,
      size = _ref21$size === void 0 ? 16 : _ref21$size,
      rest = _objectWithoutProperties(_ref21, _excluded21);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidVor.propTypes = iconPropTypes;
}
var NavaidVordme = /*#__PURE__*/React.forwardRef(function NavaidVordme(_ref22, ref) {
  var children = _ref22.children,
      _ref22$size = _ref22.size,
      size = _ref22$size === void 0 ? 16 : _ref22$size,
      rest = _objectWithoutProperties(_ref22, _excluded22);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidVordme.propTypes = iconPropTypes;
}
var NavaidVortac = /*#__PURE__*/React.forwardRef(function NavaidVortac(_ref23, ref) {
  var children = _ref23.children,
      _ref23$size = _ref23.size,
      size = _ref23$size === void 0 ? 16 : _ref23$size,
      rest = _objectWithoutProperties(_ref23, _excluded23);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NavaidVortac.propTypes = iconPropTypes;
}
var Need = /*#__PURE__*/React.forwardRef(function Need(_ref24, ref) {
  var children = _ref24.children,
      _ref24$size = _ref24.size,
      size = _ref24$size === void 0 ? 16 : _ref24$size,
      rest = _objectWithoutProperties(_ref24, _excluded24);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1211 16.8789A2.98 2.98 0 0027.01 16H27a2.9774 2.9774 0 00-2.1211.8789L19.9778 21.78A2.9943 2.9943 0 0017 19H10a5.0059 5.0059 0 00-5 5v.667L2 28.6631l1.6 1.2L7 25.333V24a3.0033 3.0033 0 013-3h7a1 1 0 010 2H13v2h4.9287a3.9717 3.9717 0 002.8286-1.1719L26.293 18.293A.9929.9929 0 0127 18h.0034a1 1 0 01.7036 1.707l-7.414 7.4141A2.9791 2.9791 0 0118.1714 28H11v2h7.1714a4.9665 4.9665 0 003.5356-1.4648l7.4141-7.4141a2.9989 2.9989 0 000-4.2422zM21.586 8.586L18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Need.propTypes = iconPropTypes;
}
var Network_1 = /*#__PURE__*/React.forwardRef(function Network_1(_ref25, ref) {
  var children = _ref25.children,
      _ref25$size = _ref25.size,
      size = _ref25$size === void 0 ? 16 : _ref25$size,
      rest = _objectWithoutProperties(_ref25, _excluded25);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20a4 4 0 114-4A4.0045 4.0045 0 0116 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 14zM5 20a4 4 0 114-4A4.0045 4.0045 0 015 20zm0-6a2 2 0 102 2A2.0023 2.0023 0 005 14zM10 31a4 4 0 114-4A4.0045 4.0045 0 0110 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 25zM22 31a4 4 0 114-4A4.0045 4.0045 0 0122 31zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 25zM27 20a4 4 0 114-4A4.0045 4.0045 0 0127 20zm0-6a2 2 0 102 2A2.0021 2.0021 0 0027 14zM22 9a4 4 0 114-4A4.0045 4.0045 0 0122 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0022 3zM10 9a4 4 0 114-4A4.0045 4.0045 0 0110 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 3z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Network_1.propTypes = iconPropTypes;
}
var Network_2 = /*#__PURE__*/React.forwardRef(function Network_2(_ref26, ref) {
  var children = _ref26.children,
      _ref26$size = _ref26.size,
      size = _ref26$size === void 0 ? 16 : _ref26$size,
      rest = _objectWithoutProperties(_ref26, _excluded26);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Network_2.propTypes = iconPropTypes;
}
var Network_3 = /*#__PURE__*/React.forwardRef(function Network_3(_ref27, ref) {
  var children = _ref27.children,
      _ref27$size = _ref27.size,
      size = _ref27$size === void 0 ? 16 : _ref27$size,
      rest = _objectWithoutProperties(_ref27, _excluded27);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15h2v2H8a4 4 0 000 8H20z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20H12V12h8Zm-6-2h4V14H14Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Network_3.propTypes = iconPropTypes;
}
var Network_3Reference = /*#__PURE__*/React.forwardRef(function Network_3Reference(_ref28, ref) {
  var children = _ref28.children,
      _ref28$size = _ref28.size,
      size = _ref28$size === void 0 ? 16 : _ref28$size,
      rest = _objectWithoutProperties(_ref28, _excluded28);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 30H22V22h8zm-6-2h4V24H24zM20 20H12V12h8zm-6-2h4V14H14z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H22V15h2a4 4 0 000-8H12V5H24a6 6 0 010 12zM10 10H2V2h8zM4 8H8V4H4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Network_3Reference.propTypes = iconPropTypes;
}
var Network_4 = /*#__PURE__*/React.forwardRef(function Network_4(_ref29, ref) {
  var children = _ref29.children,
      _ref29$size = _ref29.size,
      size = _ref29$size === void 0 ? 16 : _ref29$size,
      rest = _objectWithoutProperties(_ref29, _excluded29);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Network_4.propTypes = iconPropTypes;
}
var Network_4Reference = /*#__PURE__*/React.forwardRef(function Network_4Reference(_ref30, ref) {
  var children = _ref30.children,
      _ref30$size = _ref30.size,
      size = _ref30$size === void 0 ? 16 : _ref30$size,
      rest = _objectWithoutProperties(_ref30, _excluded30);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Network_4Reference.propTypes = iconPropTypes;
}
var NetworkAdminControl = /*#__PURE__*/React.forwardRef(function NetworkAdminControl(_ref31, ref) {
  var children = _ref31.children,
      _ref31$size = _ref31.size,
      size = _ref31$size === void 0 ? 16 : _ref31$size,
      rest = _objectWithoutProperties(_ref31, _excluded31);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20.415L25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415zM24 4a4.0045 4.0045 0 00-4 4 3.951 3.951 0 00.5669 2.019L10.019 20.5669A3.9521 3.9521 0 008 20a4 4 0 104 4 3.951 3.951 0 00-.5669-2.019L21.981 11.4331A3.9521 3.9521 0 0024 12a4 4 0 000-8zM8 26a2 2 0 112-2A2.0023 2.0023 0 018 26zM24 10a2 2 0 112-2A2.0023 2.0023 0 0124 10zM8 11.18L5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NetworkAdminControl.propTypes = iconPropTypes;
}
var NetworkEnterprise = /*#__PURE__*/React.forwardRef(function NetworkEnterprise(_ref32, ref) {
  var children = _ref32.children,
      _ref32$size = _ref32.size,
      size = _ref32$size === void 0 ? 16 : _ref32$size,
      rest = _objectWithoutProperties(_ref32, _excluded32);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H22V20H20zM24 16H26V20H24zM20 22H22V26H20zM24 22H26V26H24z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NetworkEnterprise.propTypes = iconPropTypes;
}
var NetworkOverlay = /*#__PURE__*/React.forwardRef(function NetworkOverlay(_ref33, ref) {
  var children = _ref33.children,
      _ref33$size = _ref33.size,
      size = _ref33$size === void 0 ? 16 : _ref33$size,
      rest = _objectWithoutProperties(_ref33, _excluded33);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23L13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23zM11 13L19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NetworkOverlay.propTypes = iconPropTypes;
}
var NetworkPublic = /*#__PURE__*/React.forwardRef(function NetworkPublic(_ref34, ref) {
  var children = _ref34.children,
      _ref34$size = _ref34.size,
      size = _ref34$size === void 0 ? 16 : _ref34$size,
      rest = _objectWithoutProperties(_ref34, _excluded34);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5 C27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21 c0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9 C28.3,25,26.9,26.7,25.1,27.5z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5 c-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NetworkPublic.propTypes = iconPropTypes;
}
var NewTab = /*#__PURE__*/React.forwardRef(function NewTab(_ref35, ref) {
  var children = _ref35.children,
      _ref35$size = _ref35.size,
      size = _ref35$size === void 0 ? 16 : _ref35$size,
      rest = _objectWithoutProperties(_ref35, _excluded35);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
      d: "M13,13H3V3h5V2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V8h-1V13z"
    })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
      d: "M13 3L13 1 12 1 12 3 10 3 10 4 12 4 12 6 13 6 13 4 15 4 15 3z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6L26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NewTab.propTypes = iconPropTypes;
}
var NextFilled = /*#__PURE__*/React.forwardRef(function NextFilled(_ref36, ref) {
  var children = _ref36.children,
      _ref36$size = _ref36.size,
      size = _ref36$size === void 0 ? 16 : _ref36$size,
      rest = _objectWithoutProperties(_ref36, _excluded36);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M2,16A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm6-1H20.15L14.57,9.3926,16,8l8,8-8,8-1.43-1.4272L20.15,17H8Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NextFilled.propTypes = iconPropTypes;
}
var NextOutline = /*#__PURE__*/React.forwardRef(function NextOutline(_ref37, ref) {
  var children = _ref37.children,
      _ref37$size = _ref37.size,
      size = _ref37$size === void 0 ? 16 : _ref37$size,
      rest = _objectWithoutProperties(_ref37, _excluded37);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8L14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NextOutline.propTypes = iconPropTypes;
}
var NoImage = /*#__PURE__*/React.forwardRef(function NoImage(_ref38, ref) {
  var children = _ref38.children,
      _ref38$size = _ref38.size,
      size = _ref38$size === void 0 ? 16 : _ref38$size,
      rest = _objectWithoutProperties(_ref38, _excluded38);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.4141L28.5859 2 2 28.5859 3.4141 30l2-2H26a2.0027 2.0027 0 002-2V5.4141zM26 26H7.4141l7.7929-7.793 2.3788 2.3787a2 2 0 002.8284 0L22 19l4 3.9973zm0-5.8318l-2.5858-2.5859a2 2 0 00-2.8284 0L19 19.1682l-2.377-2.3771L26 7.4141zM6 22V19l5-4.9966 1.3733 1.3733 1.4159-1.416-1.375-1.375a2 2 0 00-2.8284 0L6 16.1716V6H22V4H6A2.002 2.002 0 004 6V22z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NoImage.propTypes = iconPropTypes;
}
var NoTicket = /*#__PURE__*/React.forwardRef(function NoTicket(_ref39, ref) {
  var children = _ref39.children,
      _ref39$size = _ref39.size,
      size = _ref39$size === void 0 ? 16 : _ref39$size,
      rest = _objectWithoutProperties(_ref39, _excluded39);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6h-.5859L30 3.4141 28.5859 2 2 28.5859 3.4141 30l4-4H28a2.0027 2.0027 0 002-2V19a1 1 0 00-1-1 2 2 0 010-4 1 1 0 001-1V8A2.0023 2.0023 0 0028 6zm0 6.1265a4 4 0 000 7.7465V24H21V21H19v3H9.4141L19 14.4141V19h2V12.4141L25.4141 8H28zM4 12.1265V8H19V6H4A2.0023 2.0023 0 002 8v5a1 1 0 001 1 2 2 0 010 4 1 1 0 00-1 1v5H4V19.873a4 4 0 000-7.7465z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NoTicket.propTypes = iconPropTypes;
}
var Nominal = /*#__PURE__*/React.forwardRef(function Nominal(_ref40, ref) {
  var children = _ref40.children,
      _ref40$size = _ref40.size,
      size = _ref40$size === void 0 ? 16 : _ref40$size,
      rest = _objectWithoutProperties(_ref40, _excluded40);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
      d: "M12,8 C13.6568542,8 15,9.34314575 15,11 C15,12.6568542 13.6568542,14 12,14 C10.3431458,14 9,12.6568542 9,11 C9,9.34314575 10.3431458,8 12,8 Z M4,8 C5.65685425,8 7,9.34314575 7,11 C7,12.6568542 5.65685425,14 4,14 C2.34314575,14 1,12.6568542 1,11 C1,9.34314575 2.34314575,8 4,8 Z M12,9 C10.8954305,9 10,9.8954305 10,11 C10,12.1045695 10.8954305,13 12,13 C13.1045695,13 14,12.1045695 14,11 C14,9.8954305 13.1045695,9 12,9 Z M4,9 C2.8954305,9 2,9.8954305 2,11 C2,12.1045695 2.8954305,13 4,13 C5.1045695,13 6,12.1045695 6,11 C6,9.8954305 5.1045695,9 4,9 Z M8,2 C9.65685425,2 11,3.34314575 11,5 C11,6.65685425 9.65685425,8 8,8 C6.34314575,8 5,6.65685425 5,5 C5,3.34314575 6.34314575,2 8,2 Z M8,3 C6.8954305,3 6,3.8954305 6,5 C6,6.1045695 6.8954305,7 8,7 C9.1045695,7 10,6.1045695 10,5 C10,3.8954305 9.1045695,3 8,3 Z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28a6 6 0 116-6A6.0069 6.0069 0 0124 28zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 18zM8 28a6 6 0 116-6A6.0069 6.0069 0 018 28zM8 18a4 4 0 104 4A4.0045 4.0045 0 008 18zM16 14a6 6 0 116-6A6.0069 6.0069 0 0116 14zM16 4a4 4 0 104 4A4.0045 4.0045 0 0016 4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Nominal.propTypes = iconPropTypes;
}
var WatsonHealthNominate = /*#__PURE__*/React.forwardRef(function WatsonHealthNominate(_ref41, ref) {
  var children = _ref41.children,
      _ref41$size = _ref41.size,
      size = _ref41$size === void 0 ? 16 : _ref41$size,
      rest = _objectWithoutProperties(_ref41, _excluded41);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM10 18.59L7.41 16 6 17.41 10 21.41 17 14.41 15.59 13 10 18.59z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthNominate.propTypes = iconPropTypes;
}
var NonCertified = /*#__PURE__*/React.forwardRef(function NonCertified(_ref42, ref) {
  var children = _ref42.children,
      _ref42$size = _ref42.size,
      size = _ref42$size === void 0 ? 16 : _ref42$size,
      rest = _objectWithoutProperties(_ref42, _excluded42);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H16V10H6zM6 12H14V14H6zM6 16H10V18H6z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H7.4141L30,3.4141,28.5859,2l-2,2H4A2.0023,2.0023,0,0,0,2,6V22H4V6H24.5859L2,28.5859,3.4141,30l2-2H28a2.0023,2.0023,0,0,0,2-2V10H28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NonCertified.propTypes = iconPropTypes;
}
var NoodleBowl = /*#__PURE__*/React.forwardRef(function NoodleBowl(_ref43, ref) {
  var children = _ref43.children,
      _ref43$size = _ref43.size,
      size = _ref43$size === void 0 ? 16 : _ref43$size,
      rest = _objectWithoutProperties(_ref43, _excluded43);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4141,15l-8-8L2,8.4141,8.5859,15H2v1a14,14,0,0,0,28,0V15ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M22,8a5.0049,5.0049,0,0,0-1.5708.2554A8.0242,8.0242,0,0,0,14,5,7.9364,7.9364,0,0,0,9.0938,6.68L4.4141,2,3,3.4141,9.05,9.4648l.707-.7075A5.96,5.96,0,0,1,14,7a6.02,6.02,0,0,1,4.6875,2.2642,5.06,5.06,0,0,0-.59.61A2.9892,2.9892,0,0,1,15.7544,11H12v2h3.7544a4.98,4.98,0,0,0,3.9033-1.8745A3,3,0,0,1,25,13h2A5.0059,5.0059,0,0,0,22,8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NoodleBowl.propTypes = iconPropTypes;
}
var NotAvailable = /*#__PURE__*/React.forwardRef(function NotAvailable(_ref44, ref) {
  var children = _ref44.children,
      _ref44$size = _ref44.size,
      size = _ref44$size === void 0 ? 16 : _ref44$size,
      rest = _objectWithoutProperties(_ref44, _excluded44);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H14V17H4zM18 15H28V17H18z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NotAvailable.propTypes = iconPropTypes;
}
var NotSent = /*#__PURE__*/React.forwardRef(function NotSent(_ref45, ref) {
  var children = _ref45.children,
      _ref45$size = _ref45.size,
      size = _ref45$size === void 0 ? 16 : _ref45$size,
      rest = _objectWithoutProperties(_ref45, _excluded45);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l9.6 3.84 3.84 9.6A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM5.8 15L11.54 13l3.05 3-1.83 1.83zM17 26.2l-2.79-7L16 17.41l3 3.05zM15.69 11.45l7.64-2.78-2.78 7.64 1.56 1.56L25.94 7.34a1 1 0 00-1.28-1.28L14.13 9.89z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NotSent.propTypes = iconPropTypes;
}
var NotSentFilled = /*#__PURE__*/React.forwardRef(function NotSentFilled(_ref46, ref) {
  var children = _ref46.children,
      _ref46$size = _ref46.size,
      size = _ref46$size === void 0 ? 16 : _ref46$size,
      rest = _objectWithoutProperties(_ref46, _excluded46);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l8.59 3.43L14.59 16 16 17.41l-3.37 3.37 3.44 8.59A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM22.49 16.83l3.45-9.49a1 1 0 00-1.28-1.28L15.17 9.51z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NotSentFilled.propTypes = iconPropTypes;
}
var Notebook = /*#__PURE__*/React.forwardRef(function Notebook(_ref47, ref) {
  var children = _ref47.children,
      _ref47$size = _ref47.size,
      size = _ref47$size === void 0 ? 16 : _ref47$size,
      rest = _objectWithoutProperties(_ref47, _excluded47);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28l.002,18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Notebook.propTypes = iconPropTypes;
}
var NotebookReference = /*#__PURE__*/React.forwardRef(function NotebookReference(_ref48, ref) {
  var children = _ref48.children,
      _ref48$size = _ref48.size,
      size = _ref48$size === void 0 ? 16 : _ref48$size,
      rest = _objectWithoutProperties(_ref48, _excluded48);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 7.586 22 2 27.586 3.414 29 9 23.414 9 27 11 27 11 20 4 20zM19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H4A2.002,2.002,0,0,0,2,7V17H4V7H15V27H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM17,25V7H28l.0015,18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NotebookReference.propTypes = iconPropTypes;
}
var Notification = /*#__PURE__*/React.forwardRef(function Notification(_ref49, ref) {
  var children = _ref49.children,
      _ref49$size = _ref49.size,
      size = _ref49$size === void 0 ? 16 : _ref49$size,
      rest = _objectWithoutProperties(_ref49, _excluded49);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
      d: "M14.4,10.1L13,8.8V6.5c0-2.6-1.9-4.7-4.5-5v-1h-1v1C5,1.8,3,3.9,3,6.5v2.3l-1.4,1.3c-0.1,0.1-0.2,0.2-0.1,0.4V12 c0,0.3,0.2,0.5,0.4,0.5c0,0,0,0,0.1,0h3.5C5.5,13.9,6.6,15,8,15s2.5-1.1,2.5-2.5H14c0.3,0,0.5-0.2,0.5-0.4c0,0,0,0,0-0.1v-1.5 C14.5,10.4,14.4,10.2,14.4,10.1z M8,14c-0.8,0-1.5-0.7-1.5-1.5h3C9.5,13.3,8.8,14,8,14z M13.5,11.5h-11v-0.8l1.3-1.4 C3.9,9.3,4,9.1,4,9V6.5c0-2.2,1.8-4,4-4s4,1.8,4,4V9c0,0.1,0.1,0.3,0.1,0.4l1.4,1.3V11.5z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7071,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.2929,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v.7768a5.152,5.152,0,0,0,4.5,5.1987A5.0057,5.0057,0,0,0,21,25V24h7a1,1,0,0,0,1-1V20A1,1,0,0,0,28.7071,19.293ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13a8,8,0,0,1,16,0v4a1,1,0,0,0,.293.707L27,20.4141Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Notification.propTypes = iconPropTypes;
}
var NotificationFilled = /*#__PURE__*/React.forwardRef(function NotificationFilled(_ref50, ref) {
  var children = _ref50.children,
      _ref50$size = _ref50.size,
      size = _ref50$size === void 0 ? 16 : _ref50$size,
      rest = _objectWithoutProperties(_ref50, _excluded50);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M28.707,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20A.9993.9993,0,0,0,28.707,19.293ZM19,25a3,3,0,0,1-6,0V24h6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NotificationFilled.propTypes = iconPropTypes;
}
var NotificationNew = /*#__PURE__*/React.forwardRef(function NotificationNew(_ref51, ref) {
  var children = _ref51.children,
      _ref51$size = _ref51.size,
      size = _ref51$size === void 0 ? 16 : _ref51$size,
      rest = _objectWithoutProperties(_ref51, _excluded51);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16.5859V14H24v3a1,1,0,0,0,.293.707L27,20.4141V22H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13A7.9854,7.9854,0,0,1,20,6.0825V3.8467a9.896,9.896,0,0,0-3-.7959V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "8",
    r: "4"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NotificationNew.propTypes = iconPropTypes;
}
var NotificationOff = /*#__PURE__*/React.forwardRef(function NotificationOff(_ref52, ref) {
  var children = _ref52.children,
      _ref52$size = _ref52.size,
      size = _ref52$size === void 0 ? 16 : _ref52$size,
      rest = _objectWithoutProperties(_ref52, _excluded52);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
      d: "M2.5 11.5v-.8l1.3-1.4C3.9 9.3 4 9.1 4 9V6.5c0-2.2 1.8-4 4-4 .9 0 1.8.3 2.5.9l.7-.7C10.5 2 9.5 1.6 8.5 1.5v-1h-1v1C5 1.8 3 3.9 3 6.5v2.3l-1.4 1.3c-.1.1-.2.2-.1.4v1H2.5zM13 8.8V6.5c0-.8-.2-1.6-.5-2.2L15 1.7 14.3 1 1 14.3 1.7 15l2.5-2.5h1.3C5.5 13.9 6.6 15 8 15s2.5-1.1 2.5-2.5H14c.3 0 .5-.2.5-.4 0 0 0 0 0-.1v-1.5c0-.1-.1-.3-.1-.4L13 8.8zM8 14c-.8 0-1.5-.7-1.5-1.5h3C9.5 13.3 8.8 14 8 14zM13.5 11.5H5.2L11.7 5C11.9 5.5 12 6 12 6.5V9c0 .1.1.3.1.4l1.4 1.3V11.5z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16.5859V13a9.9217 9.9217 0 00-1.0833-4.5024L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a1 1 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zm8-3H11.4141L23.4119 10.0024A7.949 7.949 0 0124 13v4a1 1 0 00.293.707L27 20.4141zM7.707 17.707A1 1 0 008 17V13a8.0092 8.0092 0 018-8 7.9253 7.9253 0 014.9857 1.7681l1.4264-1.4263A9.934 9.934 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859l-3 3L4.4141 21z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NotificationOff.propTypes = iconPropTypes;
}
var NotificationOffFilled = /*#__PURE__*/React.forwardRef(function NotificationOffFilled(_ref53, ref) {
  var children = _ref53.children,
      _ref53$size = _ref53.size,
      size = _ref53$size === void 0 ? 16 : _ref53$size,
      rest = _objectWithoutProperties(_ref53, _excluded53);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16.5859V13a9.8828 9.8828 0 00-1.0869-4.499L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a.9993.9993 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zM21.61 4.7383A9.9256 9.9256 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859L3.293 19.293A.9993.9993 0 003 20v3a.9738.9738 0 00.0585.29z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NotificationOffFilled.propTypes = iconPropTypes;
}
var Number_0 = /*#__PURE__*/React.forwardRef(function Number_0(_ref54, ref) {
  var children = _ref54.children,
      _ref54$size = _ref54.size,
      size = _ref54$size === void 0 ? 16 : _ref54$size,
      rest = _objectWithoutProperties(_ref54, _excluded54);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11h0V21h4V11Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H17V17H15z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Number_0.propTypes = iconPropTypes;
}
var Number_1 = /*#__PURE__*/React.forwardRef(function Number_1(_ref55, ref) {
  var children = _ref55.children,
      _ref55$size = _ref55.size,
      size = _ref55$size === void 0 ? 16 : _ref55$size,
      rest = _objectWithoutProperties(_ref55, _excluded55);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10V22h0V10m1-1H12v2h3V21H12v2h8V21H17V9Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Number_1.propTypes = iconPropTypes;
}
var Number_2 = /*#__PURE__*/React.forwardRef(function Number_2(_ref56, ref) {
  var children = _ref56.children,
      _ref56$size = _ref56.size,
      size = _ref56$size === void 0 ? 16 : _ref56$size,
      rest = _objectWithoutProperties(_ref56, _excluded56);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M20,23H12V17a2,2,0,0,1,2-2h4V11H12V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H14v4h6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Number_2.propTypes = iconPropTypes;
}
var Number_3 = /*#__PURE__*/React.forwardRef(function Number_3(_ref57, ref) {
  var children = _ref57.children,
      _ref57$size = _ref57.size,
      size = _ref57$size === void 0 ? 16 : _ref57$size,
      rest = _objectWithoutProperties(_ref57, _excluded57);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H12v2h6v4H14v2h4v4H12v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Number_3.propTypes = iconPropTypes;
}
var Number_4 = /*#__PURE__*/React.forwardRef(function Number_4(_ref58, ref) {
  var children = _ref58.children,
      _ref58$size = _ref58.size,
      size = _ref58$size === void 0 ? 16 : _ref58$size,
      rest = _objectWithoutProperties(_ref58, _excluded58);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M18,10v8h0V10m1-1H17v8H14V9H12V19h5v4h2V19h1V17H19V9Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Number_4.propTypes = iconPropTypes;
}
var Number_5 = /*#__PURE__*/React.forwardRef(function Number_5(_ref59, ref) {
  var children = _ref59.children,
      _ref59$size = _ref59.size,
      size = _ref59$size === void 0 ? 16 : _ref59$size,
      rest = _objectWithoutProperties(_ref59, _excluded59);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H12V21h6V17H12V9h8v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Number_5.propTypes = iconPropTypes;
}
var Number_6 = /*#__PURE__*/React.forwardRef(function Number_6(_ref60, ref) {
  var children = _ref60.children,
      _ref60$size = _ref60.size,
      size = _ref60$size === void 0 ? 16 : _ref60$size,
      rest = _objectWithoutProperties(_ref60, _excluded60);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M18,14H14V11h5V9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16A2,2,0,0,0,18,14Zm-4,7V16h4v5Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Number_6.propTypes = iconPropTypes;
}
var Number_7 = /*#__PURE__*/React.forwardRef(function Number_7(_ref61, ref) {
  var children = _ref61.children,
      _ref61$size = _ref61.size,
      size = _ref61$size === void 0 ? 16 : _ref61$size,
      rest = _objectWithoutProperties(_ref61, _excluded61);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L12 9 12 13 14 13 14 11 17.85 11 13 23 15.16 23 20 11 20 9z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Number_7.propTypes = iconPropTypes;
}
var Number_8 = /*#__PURE__*/React.forwardRef(function Number_8(_ref62, ref) {
  var children = _ref62.children,
      _ref62$size = _ref62.size,
      size = _ref62$size === void 0 ? 16 : _ref62$size,
      rest = _objectWithoutProperties(_ref62, _excluded62);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,2v4H14V11ZM14,21V17h4v4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Number_8.propTypes = iconPropTypes;
}
var Number_9 = /*#__PURE__*/React.forwardRef(function Number_9(_ref63, ref) {
  var children = _ref63.children,
      _ref63$size = _ref63.size,
      size = _ref63$size === void 0 ? 16 : _ref63$size,
      rest = _objectWithoutProperties(_ref63, _excluded63);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H14a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h4v3H13v2h5a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,7H14V11h4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Number_9.propTypes = iconPropTypes;
}
var NumberSmall_0 = /*#__PURE__*/React.forwardRef(function NumberSmall_0(_ref64, ref) {
  var children = _ref64.children,
      _ref64$size = _ref64.size,
      size = _ref64$size === void 0 ? 16 : _ref64$size,
      rest = _objectWithoutProperties(_ref64, _excluded64);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v6h2V13Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NumberSmall_0.propTypes = iconPropTypes;
}
var NumberSmall_1 = /*#__PURE__*/React.forwardRef(function NumberSmall_1(_ref65, ref) {
  var children = _ref65.children,
      _ref65$size = _ref65.size,
      size = _ref65$size === void 0 ? 16 : _ref65$size,
      rest = _objectWithoutProperties(_ref65, _excluded65);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NumberSmall_1.propTypes = iconPropTypes;
}
var NumberSmall_2 = /*#__PURE__*/React.forwardRef(function NumberSmall_2(_ref66, ref) {
  var children = _ref66.children,
      _ref66$size = _ref66.size,
      size = _ref66$size === void 0 ? 16 : _ref66$size,
      rest = _objectWithoutProperties(_ref66, _excluded66);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21H13V17a2,2,0,0,1,2-2h2V13H13V11h4a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H15v2h4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NumberSmall_2.propTypes = iconPropTypes;
}
var NumberSmall_3 = /*#__PURE__*/React.forwardRef(function NumberSmall_3(_ref67, ref) {
  var children = _ref67.children,
      _ref67$size = _ref67.size,
      size = _ref67$size === void 0 ? 16 : _ref67$size,
      rest = _objectWithoutProperties(_ref67, _excluded67);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M17,11H13v2h4v2H14v2h3v2H13v2h4a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NumberSmall_3.propTypes = iconPropTypes;
}
var NumberSmall_4 = /*#__PURE__*/React.forwardRef(function NumberSmall_4(_ref68, ref) {
  var children = _ref68.children,
      _ref68$size = _ref68.size,
      size = _ref68$size === void 0 ? 16 : _ref68$size,
      rest = _objectWithoutProperties(_ref68, _excluded68);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11L17 15 15 15 15 11 13 11 13 17 17 17 17 21 19 21 19 11 17 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NumberSmall_4.propTypes = iconPropTypes;
}
var NumberSmall_5 = /*#__PURE__*/React.forwardRef(function NumberSmall_5(_ref69, ref) {
  var children = _ref69.children,
      _ref69$size = _ref69.size,
      size = _ref69$size === void 0 ? 16 : _ref69$size,
      rest = _objectWithoutProperties(_ref69, _excluded69);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H13V19h4V17H13V11h6v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NumberSmall_5.propTypes = iconPropTypes;
}
var NumberSmall_6 = /*#__PURE__*/React.forwardRef(function NumberSmall_6(_ref70, ref) {
  var children = _ref70.children,
      _ref70$size = _ref70.size,
      size = _ref70$size === void 0 ? 16 : _ref70$size,
      rest = _objectWithoutProperties(_ref70, _excluded70);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Zm-2-4v2h2V17Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NumberSmall_6.propTypes = iconPropTypes;
}
var NumberSmall_7 = /*#__PURE__*/React.forwardRef(function NumberSmall_7(_ref71, ref) {
  var children = _ref71.children,
      _ref71$size = _ref71.size,
      size = _ref71$size === void 0 ? 16 : _ref71$size,
      rest = _objectWithoutProperties(_ref71, _excluded71);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M16.44 21L14.44 21 17 13 15 13 15 14 13 14 13 11 19 11 19 13 16.44 21z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NumberSmall_7.propTypes = iconPropTypes;
}
var NumberSmall_8 = /*#__PURE__*/React.forwardRef(function NumberSmall_8(_ref72, ref) {
  var children = _ref72.children,
      _ref72$size = _ref72.size,
      size = _ref72$size === void 0 ? 16 : _ref72$size,
      rest = _objectWithoutProperties(_ref72, _excluded72);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M17,11H15a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Zm0,2v2H15V13Zm-2,6V17h2v2Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NumberSmall_8.propTypes = iconPropTypes;
}
var NumberSmall_9 = /*#__PURE__*/React.forwardRef(function NumberSmall_9(_ref73, ref) {
  var children = _ref73.children,
      _ref73$size = _ref73.size,
      size = _ref73$size === void 0 ? 16 : _ref73$size,
      rest = _objectWithoutProperties(_ref73, _excluded73);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H14V19h3V17H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v2h2V13Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  NumberSmall_9.propTypes = iconPropTypes;
}
var ObjectStorage = /*#__PURE__*/React.forwardRef(function ObjectStorage(_ref74, ref) {
  var children = _ref74.children,
      _ref74$size = _ref74.size,
      size = _ref74$size === void 0 ? 16 : _ref74$size,
      rest = _objectWithoutProperties(_ref74, _excluded74);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H14V20H4a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,28,20Z"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M30 8H22v6H16v8h8V16h6zM22 20H18V16h4zm6-6H24V10h4zM18 10H10V2h8zM12 8h4V4H12z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ObjectStorage.propTypes = iconPropTypes;
}
var ObjectStorageAlt = /*#__PURE__*/React.forwardRef(function ObjectStorageAlt(_ref75, ref) {
  var children = _ref75.children,
      _ref75$size = _ref75.size,
      size = _ref75$size === void 0 ? 16 : _ref75$size,
      rest = _objectWithoutProperties(_ref75, _excluded75);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H14V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M21,14a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023A2.9578,2.9578,0,0,0,15,12a2.9578,2.9578,0,0,0-.0413-.4087L18.9626,9.189A2.9909,2.9909,0,1,0,18,7a2.9345,2.9345,0,0,0,.0415.4092L14.0376,9.8115a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,18,17a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,6Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,12,13Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ObjectStorageAlt.propTypes = iconPropTypes;
}
var ObservedHail = /*#__PURE__*/React.forwardRef(function ObservedHail(_ref76, ref) {
  var children = _ref76.children,
      _ref76$size = _ref76.size,
      size = _ref76$size === void 0 ? 16 : _ref76$size,
      rest = _objectWithoutProperties(_ref76, _excluded76);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "13.5",
    cy: "23.5",
    r: "1.5"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "19.5",
    r: "1.5"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "16.5",
    cy: "19.5",
    r: "1.5"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M11.964 14.5H17.036V16.499H11.964z",
    transform: "rotate(-45 14.5 15.5)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M17.964 14.5H23.035999999999998V16.499H17.964z",
    transform: "rotate(-45 20.5 15.5)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ObservedHail.propTypes = iconPropTypes;
}
var ObservedLightning = /*#__PURE__*/React.forwardRef(function ObservedLightning(_ref77, ref) {
  var children = _ref77.children,
      _ref77$size = _ref77.size,
      size = _ref77$size === void 0 ? 16 : _ref77$size,
      rest = _objectWithoutProperties(_ref77, _excluded77);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ObservedLightning.propTypes = iconPropTypes;
}
var Omega = /*#__PURE__*/React.forwardRef(function Omega(_ref78, ref) {
  var children = _ref78.children,
      _ref78$size = _ref78.size,
      size = _ref78$size === void 0 ? 16 : _ref78$size,
      rest = _objectWithoutProperties(_ref78, _excluded78);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7373,25A14.3093,14.3093,0,0,0,27,15C27,8.42,22.58,4,16,4S5,8.42,5,15A14.3093,14.3093,0,0,0,9.2627,25H4v2h8V24.7617A12.5683,12.5683,0,0,1,7,15c0-5.4673,3.5327-9,9-9s9,3.5327,9,9a12.5683,12.5683,0,0,1-5,9.7617V27h8V25Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Omega.propTypes = iconPropTypes;
}
var Opacity = /*#__PURE__*/React.forwardRef(function Opacity(_ref79, ref) {
  var children = _ref79.children,
      _ref79$size = _ref79.size,
      size = _ref79$size === void 0 ? 16 : _ref79$size,
      rest = _objectWithoutProperties(_ref79, _excluded79);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V10H6zM10 10H14V14H10zM14 6H18V10H14zM22 6H26V10H22zM6 14H10V18H6zM14 14H18V18H14zM22 14H26V18H22zM6 22H10V26H6zM14 22H18V26H14zM22 22H26V26H22zM18 10H22V14H18zM10 18H14V22H10zM18 18H22V22H18z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Opacity.propTypes = iconPropTypes;
}
var OpenPanelBottom = /*#__PURE__*/React.forwardRef(function OpenPanelBottom(_ref80, ref) {
  var children = _ref80.children,
      _ref80$size = _ref80.size,
      size = _ref80$size === void 0 ? 16 : _ref80$size,
      rest = _objectWithoutProperties(_ref80, _excluded80);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6ZM4,26V20H28v6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OpenPanelBottom.propTypes = iconPropTypes;
}
var OpenPanelFilledBottom = /*#__PURE__*/React.forwardRef(function OpenPanelFilledBottom(_ref81, ref) {
  var children = _ref81.children,
      _ref81$size = _ref81.size,
      size = _ref81$size === void 0 ? 16 : _ref81$size,
      rest = _objectWithoutProperties(_ref81, _excluded81);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OpenPanelFilledBottom.propTypes = iconPropTypes;
}
var OpenPanelFilledLeft = /*#__PURE__*/React.forwardRef(function OpenPanelFilledLeft(_ref82, ref) {
  var children = _ref82.children,
      _ref82$size = _ref82.size,
      size = _ref82$size === void 0 ? 16 : _ref82$size,
      rest = _objectWithoutProperties(_ref82, _excluded82);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V6H28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OpenPanelFilledLeft.propTypes = iconPropTypes;
}
var OpenPanelFilledRight = /*#__PURE__*/React.forwardRef(function OpenPanelFilledRight(_ref83, ref) {
  var children = _ref83.children,
      _ref83$size = _ref83.size,
      size = _ref83$size === void 0 ? 16 : _ref83$size,
      rest = _objectWithoutProperties(_ref83, _excluded83);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OpenPanelFilledRight.propTypes = iconPropTypes;
}
var OpenPanelFilledTop = /*#__PURE__*/React.forwardRef(function OpenPanelFilledTop(_ref84, ref) {
  var children = _ref84.children,
      _ref84$size = _ref84.size,
      size = _ref84$size === void 0 ? 16 : _ref84$size,
      rest = _objectWithoutProperties(_ref84, _excluded84);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,26V14H28V26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OpenPanelFilledTop.propTypes = iconPropTypes;
}
var OpenPanelLeft = /*#__PURE__*/React.forwardRef(function OpenPanelLeft(_ref85, ref) {
  var children = _ref85.children,
      _ref85$size = _ref85.size,
      size = _ref85$size === void 0 ? 16 : _ref85$size,
      rest = _objectWithoutProperties(_ref85, _excluded85);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6h6V26H4ZM28,26H12V6H28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OpenPanelLeft.propTypes = iconPropTypes;
}
var OpenPanelRight = /*#__PURE__*/React.forwardRef(function OpenPanelRight(_ref86, ref) {
  var children = _ref86.children,
      _ref86$size = _ref86.size,
      size = _ref86$size === void 0 ? 16 : _ref86$size,
      rest = _objectWithoutProperties(_ref86, _excluded86);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4ZM28,26H22V6h6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OpenPanelRight.propTypes = iconPropTypes;
}
var OpenPanelTop = /*#__PURE__*/React.forwardRef(function OpenPanelTop(_ref87, ref) {
  var children = _ref87.children,
      _ref87$size = _ref87.size,
      size = _ref87$size === void 0 ? 16 : _ref87$size,
      rest = _objectWithoutProperties(_ref87, _excluded87);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2v6H4V6ZM4,26V14H28V26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OpenPanelTop.propTypes = iconPropTypes;
}
var QOperation = /*#__PURE__*/React.forwardRef(function QOperation(_ref88, ref) {
  var children = _ref88.children,
      _ref88$size = _ref88.size,
      size = _ref88$size === void 0 ? 16 : _ref88$size,
      rest = _objectWithoutProperties(_ref88, _excluded88);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26L21 26 26 16 21 6 23 6 28 16 23 26zM4 6H6V26H4zM16 9H12a2 2 0 00-2 2V21a2 2 0 002 2h4a2 2 0 002-2V11A2 2 0 0016 9zm0 12H12V11h4z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H15V17H13z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  QOperation.propTypes = iconPropTypes;
}
var QOperationGauge = /*#__PURE__*/React.forwardRef(function QOperationGauge(_ref89, ref) {
  var children = _ref89.children,
      _ref89$size = _ref89.size,
      size = _ref89$size === void 0 ? 16 : _ref89$size,
      rest = _objectWithoutProperties(_ref89, _excluded89);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4L24 4 24 6 27.75 6 24 10 24 12 30 12 30 10 26.38 10 30 6 30 4zM20 17.62L22.08 14l-1.73-1-2.18 3.76A12 12 0 002 28H4a10 10 0 0113.16-9.48L14 24a2 2 0 102 2 2 2 0 00-.27-1L19 19.35A10 10 0 0124 28h2A12 12 0 0020 17.62z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  QOperationGauge.propTypes = iconPropTypes;
}
var QOperationIf = /*#__PURE__*/React.forwardRef(function QOperationIf(_ref90, ref) {
  var children = _ref90.children,
      _ref90$size = _ref90.size,
      size = _ref90$size === void 0 ? 16 : _ref90$size,
      rest = _objectWithoutProperties(_ref90, _excluded90);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13H14V23H12zM12 9H14V11H12zM23 11V9H20a2 2 0 00-2 2v2H16v2h2v8h2V15h3V13H20V11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  QOperationIf.propTypes = iconPropTypes;
}
var OperationsField = /*#__PURE__*/React.forwardRef(function OperationsField(_ref91, ref) {
  var children = _ref91.children,
      _ref91$size = _ref91.size,
      size = _ref91$size === void 0 ? 16 : _ref91$size,
      rest = _objectWithoutProperties(_ref91, _excluded91);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H26V8H16z",
    transform: "rotate(-90 21 7)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H30V8H20z",
    transform: "rotate(-90 25 7)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H34V8H24z",
    transform: "rotate(-90 29 7)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4V10a6,6,0,1,0,6,6H20A3.9123,3.9123,0,0,1,16,20Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8928,18.4536,26.0979,16,24.78,17.5044l2.7922,2.4517-2.36,4.0878-3.4273-1.1591a9.0315,9.0315,0,0,1-2.7143,1.5644L18.36,28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H16V2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18.36a2,2,0,0,0,1.9611-1.6079l.5037-2.5186a10.9666,10.9666,0,0,0,1.3267-.7534l2.4194.8184a1.9977,1.9977,0,0,0,2.3728-.8946l2.3606-4.0878A2.0006,2.0006,0,0,0,28.8928,18.4536Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OperationsField.propTypes = iconPropTypes;
}
var OperationsRecord = /*#__PURE__*/React.forwardRef(function OperationsRecord(_ref92, ref) {
  var children = _ref92.children,
      _ref92$size = _ref92.size,
      size = _ref92$size === void 0 ? 16 : _ref92$size,
      rest = _objectWithoutProperties(_ref92, _excluded92);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H30V22H20zM20 24H30V26H20zM20 28H30V30H20zM16 20a3.9123 3.9123 0 01-4-4 3.9123 3.9123 0 014-4 3.9123 3.9123 0 014 4h2a6 6 0 10-6 6z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H16V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OperationsRecord.propTypes = iconPropTypes;
}
var OrderDetails = /*#__PURE__*/React.forwardRef(function OrderDetails(_ref93, ref) {
  var children = _ref93.children,
      _ref93$size = _ref93.size,
      size = _ref93$size === void 0 ? 16 : _ref93$size,
      rest = _objectWithoutProperties(_ref93, _excluded93);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21H13a3 3 0 00-3 3v2h2V24a1 1 0 011-1h6a1 1 0 011 1v2h2V24A3 3 0 0019 21zM16 20a4 4 0 10-4-4A4 4 0 0016 20zm0-6a2 2 0 11-2 2A2 2 0 0116 14z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OrderDetails.propTypes = iconPropTypes;
}
var Ordinal = /*#__PURE__*/React.forwardRef(function Ordinal(_ref94, ref) {
  var children = _ref94.children,
      _ref94$size = _ref94.size,
      size = _ref94$size === void 0 ? 16 : _ref94$size,
      rest = _objectWithoutProperties(_ref94, _excluded94);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
      d: "M1,13 L1,12 L3,12 L3,9 L5.999,9 L6,6 L9,6 L9,3 L13,3 L13,12 L15,12 L15,13 L1,13 Z M5.999,10 L4,10 L4,12 L5.999,12 L5.999,10 Z M8.999,7 L6.999,7 L6.999,9 L7,9 L7,12 L8.999,12 L8.999,7 Z M12,4 L10,4 L10,12 L12,12 L12,4 Z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26V4H18v6H12v6H6V26H2v2H30V26ZM8,26V18h4v8Zm6,0V12h4V26Zm6,0V6h4V26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Ordinal.propTypes = iconPropTypes;
}
var Outage = /*#__PURE__*/React.forwardRef(function Outage(_ref95, ref) {
  var children = _ref95.children,
      _ref95$size = _ref95.size,
      size = _ref95$size === void 0 ? 16 : _ref95$size,
      rest = _objectWithoutProperties(_ref95, _excluded95);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H21V26H12zM13 28H19V30H13z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7832 18.9746l1.4177-1.418A6.9206 6.9206 0 018 12 7.99 7.99 0 0121.5273 6.2305l1.4136-1.4136A9.9884 9.9884 0 006 12 8.9411 8.9411 0 008.7832 18.9746zM30 3.4141L28.5859 2 2 28.5859 3.4141 30 23.6606 9.7534A7.7069 7.7069 0 0124 12a7.2032 7.2032 0 01-2.8223 6.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12a9.8739 9.8739 0 00-.7764-3.81z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Outage.propTypes = iconPropTypes;
}
var OutlookSevere = /*#__PURE__*/React.forwardRef(function OutlookSevere(_ref96, ref) {
  var children = _ref96.children,
      _ref96$size = _ref96.size,
      size = _ref96$size === void 0 ? 16 : _ref96$size,
      rest = _objectWithoutProperties(_ref96, _excluded96);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M15.1249,19h1.75v5.5h-1.75ZM17,27a1,1,0,1,0-1,1A1,1,0,0,0,17,27Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9084,28.94,16.8318,14.4878a.9531.9531,0,0,0-1.6636,0L7.0916,28.94A.7122.7122,0,0,0,7.7134,30H24.2867A.7121.7121,0,0,0,24.9084,28.94ZM15.125,19h1.75v5.5h-1.75ZM16,28a1,1,0,1,1,1-1A1,1,0,0,1,16,28Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4926,6.4926,0,0,0,.9153,12.8443L9.2217,20H8.5a4.48,4.48,0,0,1-3.3693-7.4556l5.297,5.2964,1.013-1.8135-4.66-4.6606A4.402,4.402,0,0,1,8.144,11.019l.8155-.0639.0991-.812c.0237-.1944.0581-.3848.0972-.5733l3.78,3.7808,1.0138-1.815L9.936,7.522a7.0212,7.0212,0,0,1,1.9754-2.1968L25.8861,19.3A4.4594,4.4594,0,0,1,23.5,20h-.7239l1.107,1.98a6.4927,6.4927,0,0,0,.9177-12.8443Zm2.4994,8.75L13.7823,4.3682a6.9736,6.9736,0,0,1,9.16,5.7749l.0986.812.8154.0639A4.5171,4.5171,0,0,1,28,15.5,4.46,4.46,0,0,1,27.3,17.8862Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OutlookSevere.propTypes = iconPropTypes;
}
var OverflowMenuHorizontal = /*#__PURE__*/React.forwardRef(function OverflowMenuHorizontal(_ref97, ref) {
  var children = _ref97.children,
      _ref97$size = _ref97.size,
      size = _ref97$size === void 0 ? 16 : _ref97$size,
      rest = _objectWithoutProperties(_ref97, _excluded97);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "16",
    r: "2"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OverflowMenuHorizontal.propTypes = iconPropTypes;
}
var OverflowMenuVertical = /*#__PURE__*/React.forwardRef(function OverflowMenuVertical(_ref98, ref) {
  var children = _ref98.children,
      _ref98$size = _ref98.size,
      size = _ref98$size === void 0 ? 16 : _ref98$size,
      rest = _objectWithoutProperties(_ref98, _excluded98);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "8",
    r: "2"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  OverflowMenuVertical.propTypes = iconPropTypes;
}
var Overlay = /*#__PURE__*/React.forwardRef(function Overlay(_ref99, ref) {
  var children = _ref99.children,
      _ref99$size = _ref99.size,
      size = _ref99$size === void 0 ? 16 : _ref99$size,
      rest = _objectWithoutProperties(_ref99, _excluded99);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM4,22V4H22V8H10a2.0023,2.0023,0,0,0-2,2V22Zm18,0H19.4141L10,12.586V10h2.5859l9.4153,9.4156ZM10,15.4141,16.5859,22H10ZM22.001,16.587,15.4141,10H22ZM10,28V24H22a2.0023,2.0023,0,0,0,2-2V10h4V28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Overlay.propTypes = iconPropTypes;
}
var Package = /*#__PURE__*/React.forwardRef(function Package(_ref100, ref) {
  var children = _ref100.children,
      _ref100$size = _ref100.size,
      size = _ref100$size === void 0 ? 16 : _ref100$size,
      rest = _objectWithoutProperties(_ref100, _excluded100);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H9v2H6V28H26V16H23V14h3a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20H19V22H13zM20.59 8.59L17 12.17 17 2 15 2 15 12.17 11.41 8.59 10 10 16 16 22 10 20.59 8.59z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Package.propTypes = iconPropTypes;
}
var PageFirst = /*#__PURE__*/React.forwardRef(function PageFirst(_ref101, ref) {
  var children = _ref101.children,
      _ref101$size = _ref101.size,
      size = _ref101$size === void 0 ? 16 : _ref101$size,
      rest = _objectWithoutProperties(_ref101, _excluded101);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16L24 6 25.4 7.4 16.8 16 25.4 24.6 24 26zM8 4H10V28H8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PageFirst.propTypes = iconPropTypes;
}
var PageLast = /*#__PURE__*/React.forwardRef(function PageLast(_ref102, ref) {
  var children = _ref102.children,
      _ref102$size = _ref102.size,
      size = _ref102$size === void 0 ? 16 : _ref102$size,
      rest = _objectWithoutProperties(_ref102, _excluded102);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16L8 26 6.6 24.6 15.2 16 6.6 7.4 8 6zM22 4H24V28H22z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PageLast.propTypes = iconPropTypes;
}
var PageBreak = /*#__PURE__*/React.forwardRef(function PageBreak(_ref103, ref) {
  var children = _ref103.children,
      _ref103$size = _ref103.size,
      size = _ref103$size === void 0 ? 16 : _ref103$size,
      rest = _objectWithoutProperties(_ref103, _excluded103);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6V20H2zM26 18H30V20H26zM24 22v6H8V22H6v6a2.0058 2.0058 0 002 2H24a2.0058 2.0058 0 002-2V22zM8 16V4h8v6a2.0058 2.0058 0 002 2h6v4h2V10a.9092.9092 0 00-.3-.7l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16zM18 4.4L23.6 10H18zM10 18H14V20H10zM18 18H22V20H18z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PageBreak.propTypes = iconPropTypes;
}
var PageNumber = /*#__PURE__*/React.forwardRef(function PageNumber(_ref104, ref) {
  var children = _ref104.children,
      _ref104$size = _ref104.size,
      size = _ref104$size === void 0 ? 16 : _ref104$size,
      rest = _objectWithoutProperties(_ref104, _excluded104);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26L16 26 16 20 20 20 20 18 16 18 16 16 22 16 22 22 18 22 18 24 22 24 22 26z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PageNumber.propTypes = iconPropTypes;
}
var WatsonHealthPageScroll = /*#__PURE__*/React.forwardRef(function WatsonHealthPageScroll(_ref105, ref) {
  var children = _ref105.children,
      _ref105$size = _ref105.size,
      size = _ref105$size === void 0 ? 16 : _ref105$size,
      rest = _objectWithoutProperties(_ref105, _excluded105);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H4a1.89,1.89,0,0,1-2-2V14a1.89,1.89,0,0,1,2-2H16a1.89,1.89,0,0,1,2,2V26A1.89,1.89,0,0,1,16,28ZM4,14V26H16V14Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M22,19H20V10H10V8H20a1.89,1.89,0,0,1,2,2Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14H24V6H16V4h8a1.89 1.89 0 012 2zM24 17L24 19 26.8 19 22 24.4 22 22 20 22 20 28 26 28 26 26 23.2 26 28 20.6 28 23 30 23 30 17 24 17z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthPageScroll.propTypes = iconPropTypes;
}
var PaintBrush = /*#__PURE__*/React.forwardRef(function PaintBrush(_ref106, ref) {
  var children = _ref106.children,
      _ref106$size = _ref106.size,
      size = _ref106$size === void 0 ? 16 : _ref106$size,
      rest = _objectWithoutProperties(_ref106, _excluded106);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M28.83,23.17,23,17.33V13a1,1,0,0,0-.29-.71l-10-10a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42l10,10A1,1,0,0,0,13,23h4.34l5.83,5.84a4,4,0,0,0,5.66-5.66ZM6,10.41l2.29,2.3,1.42-1.42L7.41,9,9,7.41l4.29,4.3,1.42-1.42L10.41,6,12,4.41,18.59,11,11,18.59,4.41,12Zm21.41,17a2,2,0,0,1-2.82,0l-6.13-6.12a1.8,1.8,0,0,0-.71-.29H13.41l-1-1L20,12.41l1,1v4.34a1,1,0,0,0,.29.7l6.12,6.14a2,2,0,0,1,0,2.82Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PaintBrush.propTypes = iconPropTypes;
}
var PaintBrushAlt = /*#__PURE__*/React.forwardRef(function PaintBrushAlt(_ref107, ref) {
  var children = _ref107.children,
      _ref107$size = _ref107.size,
      size = _ref107$size === void 0 ? 16 : _ref107$size,
      rest = _objectWithoutProperties(_ref107, _excluded107);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9671,4.9671,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PaintBrushAlt.propTypes = iconPropTypes;
}
var PalmTree = /*#__PURE__*/React.forwardRef(function PalmTree(_ref108, ref) {
  var children = _ref108.children,
      _ref108$size = _ref108.size,
      size = _ref108$size === void 0 ? 16 : _ref108$size,
      rest = _objectWithoutProperties(_ref108, _excluded108);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M18.57,28C17.897,26.7251,16,22.2261,16,12v-.1313l1.1172.7446A6.4613,6.4613,0,0,1,20,18h2a8.457,8.457,0,0,0-3.7734-7.0508L16.8027,10h1.5308a7.04,7.04,0,0,1,4.2,1.4L24.4,12.8l1.2-1.6L23.7334,9.8a9.06,9.06,0,0,0-5.4-1.8H17.1172A7.0306,7.0306,0,0,1,22,6h2V4H22a9.035,9.035,0,0,0-7,3.3643A9.035,9.035,0,0,0,8,4H6V6H8a7.0306,7.0306,0,0,1,4.8828,2H11.6665a9.06,9.06,0,0,0-5.4,1.8L4.4,11.2l1.2,1.6L7.4668,11.4a7.04,7.04,0,0,1,4.2-1.4h1.5308l-1.4239.9492A8.457,8.457,0,0,0,8,18h2a6.4613,6.4613,0,0,1,2.8828-5.3867L14,11.8687V12c0,8.9438,1.4116,13.7646,2.3611,16H2v2H30V28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PalmTree.propTypes = iconPropTypes;
}
var PanHorizontal = /*#__PURE__*/React.forwardRef(function PanHorizontal(_ref109, ref) {
  var children = _ref109.children,
      _ref109$size = _ref109.size,
      size = _ref109$size === void 0 ? 16 : _ref109$size,
      rest = _objectWithoutProperties(_ref109, _excluded109);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10L22.586 11.414 26.172 15 5.828 15 9.414 11.414 8 10 2 16 8 22 9.414 20.586 5.828 17 26.172 17 22.586 20.586 24 22 30 16 24 10z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PanHorizontal.propTypes = iconPropTypes;
}
var PanVertical = /*#__PURE__*/React.forwardRef(function PanVertical(_ref110, ref) {
  var children = _ref110.children,
      _ref110$size = _ref110.size,
      size = _ref110$size === void 0 ? 16 : _ref110$size,
      rest = _objectWithoutProperties(_ref110, _excluded110);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8L11.414 9.414 15 5.828 15 26.172 11.414 22.586 10 24 16 30 22 24 20.586 22.586 17 26.172 17 5.828 20.586 9.414 22 8 16 2 10 8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PanVertical.propTypes = iconPropTypes;
}
var PanelExpansion = /*#__PURE__*/React.forwardRef(function PanelExpansion(_ref111, ref) {
  var children = _ref111.children,
      _ref111$size = _ref111.size,
      size = _ref111$size === void 0 ? 16 : _ref111$size,
      rest = _objectWithoutProperties(_ref111, _excluded111);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H6A2 2 0 004 8v6a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0012 6zM6 14V8h6v6zM26 6H20a2 2 0 00-2 2V24a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0026 6zM20 24V8h6V24z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PanelExpansion.propTypes = iconPropTypes;
}
var Paragraph = /*#__PURE__*/React.forwardRef(function Paragraph(_ref112, ref) {
  var children = _ref112.children,
      _ref112$size = _ref112.size,
      size = _ref112$size === void 0 ? 16 : _ref112$size,
      rest = _objectWithoutProperties(_ref112, _excluded112);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H13a7,7,0,0,0,0,14V28h2V6h5V28h2V6h5ZM13,16A5,5,0,0,1,13,6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Paragraph.propTypes = iconPropTypes;
}
var Parameter = /*#__PURE__*/React.forwardRef(function Parameter(_ref113, ref) {
  var children = _ref113.children,
      _ref113$size = _ref113.size,
      size = _ref113$size === void 0 ? 16 : _ref113$size,
      rest = _objectWithoutProperties(_ref113, _excluded113);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M28,13V8a2.0023,2.0023,0,0,0-2-2H23V8h3v5a3.9756,3.9756,0,0,0,1.3823,3A3.9756,3.9756,0,0,0,26,19v5H23v2h3a2.0023,2.0023,0,0,0,2-2V19a2.0023,2.0023,0,0,1,2-2V15A2.0023,2.0023,0,0,1,28,13Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17,9l-.857,3h2L19,9h2l-.857,3H22v2H19.572l-1.143,4H21v2H17.857L17,23H15l.857-3h-2L13,23H11l.857-3H10V18h2.429l1.143-4H11V12h3.143L15,9Zm.572,5h-2l-1.143,4h2Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M6,13V8H9V6H6A2.0023,2.0023,0,0,0,4,8v5a2.0023,2.0023,0,0,1-2,2v2a2.0023,2.0023,0,0,1,2,2v5a2.0023,2.0023,0,0,0,2,2H9V24H6V19a3.9756,3.9756,0,0,0-1.3823-3A3.9756,3.9756,0,0,0,6,13Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Parameter.propTypes = iconPropTypes;
}
var ParentChild = /*#__PURE__*/React.forwardRef(function ParentChild(_ref114, ref) {
  var children = _ref114.children,
      _ref114$size = _ref114.size,
      size = _ref114$size === void 0 ? 16 : _ref114$size,
      rest = _objectWithoutProperties(_ref114, _excluded114);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v6a2,2,0,0,0,2,2H15v4H9a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H9V18H23v4H20a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H25V18a2,2,0,0,0-2-2H17V12ZM12,28H4V24h8Zm16,0H20V24h8ZM4,4H28v6H4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ParentChild.propTypes = iconPropTypes;
}
var PartlyCloudy = /*#__PURE__*/React.forwardRef(function PartlyCloudy(_ref115, ref) {
  var children = _ref115.children,
      _ref115$size = _ref115.size,
      size = _ref115$size === void 0 ? 16 : _ref115$size,
      rest = _objectWithoutProperties(_ref115, _excluded115);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15H31V17H27z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M23.086 5.794H27.329V7.794H23.086z",
    transform: "rotate(-45 25.207 6.794)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1H17V5H15z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M4.672 24.208H8.915V26.208H4.672z",
    transform: "rotate(-45 6.793 25.208)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M5.793 4.672H7.793V8.915H5.793z",
    transform: "rotate(-45 6.793 6.794)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15H5V17H1zM26.7939 20.3418a6.9617 6.9617 0 00-1.8681-3.2671A8.485 8.485 0 0025 16a9 9 0 10-14.585 7.0332A4.9771 4.9771 0 0015 30H25a4.9947 4.9947 0 001.7939-9.6582zM9 16a6.9955 6.9955 0 0113.9849-.2969A6.8883 6.8883 0 0020 15a7.04 7.04 0 00-6.7944 5.3418A4.986 4.986 0 0011.5618 21.39 6.9675 6.9675 0 019 16zM25 28H15a2.9945 2.9945 0 01-.6963-5.9082l.6587-.1572.0986-.67a4.9923 4.9923 0 019.878 0l.0986.6695.6587.1572A2.9945 2.9945 0 0125 28z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PartlyCloudy.propTypes = iconPropTypes;
}
var PartlyCloudyNight = /*#__PURE__*/React.forwardRef(function PartlyCloudyNight(_ref116, ref) {
  var children = _ref116.children,
      _ref116$size = _ref116.size,
      size = _ref116$size === void 0 ? 16 : _ref116$size,
      rest = _objectWithoutProperties(_ref116, _excluded116);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M30,19a4.974,4.974,0,0,0-3.2061-4.6582A6.9711,6.9711,0,0,0,13.7578,12.9a13.1418,13.1418,0,0,1,.1314-8.52A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0a13.0412,13.0412,0,0,0,10.29-5.0386A4.99,4.99,0,0,0,30,19ZM14.7034,26.9976a11.0945,11.0945,0,0,1-3.201-21.584,15.1817,15.1817,0,0,0,.8443,9.3676A4.9877,4.9877,0,0,0,15,24h7.6772a11.0991,11.0991,0,0,1-7.5561,2.9976C14.9827,26.9976,14.8428,27.0024,14.7034,26.9976ZM25,22H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878.0005l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,22Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PartlyCloudyNight.propTypes = iconPropTypes;
}
var Partnership = /*#__PURE__*/React.forwardRef(function Partnership(_ref117, ref) {
  var children = _ref117.children,
      _ref117$size = _ref117.size,
      size = _ref117$size === void 0 ? 16 : _ref117$size,
      rest = _objectWithoutProperties(_ref117, _excluded117);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9a4 4 0 114-4A4 4 0 018 9zM8 3a2 2 0 102 2A2 2 0 008 3zM24 9a4 4 0 114-4A4 4 0 0124 9zm0-6a2 2 0 102 2A2 2 0 0024 3zM26 30H22a2 2 0 01-2-2V21h2v7h4V19h2V13a1 1 0 00-1-1H20.58L16 20l-4.58-8H5a1 1 0 00-1 1v6H6v9h4V21h2v7a2 2 0 01-2 2H6a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h7.58L16 16l3.42-6H27a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0126 30z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Partnership.propTypes = iconPropTypes;
}
var PassengerDrinks = /*#__PURE__*/React.forwardRef(function PassengerDrinks(_ref118, ref) {
  var children = _ref118.children,
      _ref118$size = _ref118.size,
      size = _ref118$size === void 0 ? 16 : _ref118$size,
      rest = _objectWithoutProperties(_ref118, _excluded118);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4V2H22V4a3.9906 3.9906 0 003 3.8586V11H23v2h6V11H27V7.8586A3.9906 3.9906 0 0030 4zM10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4746 31.313L19.3408 24H12.2393A4.0073 4.0073 0 018.373 21.0293l-1.6337-6.126a3.8987 3.8987 0 017.5341-2.0092L15.1016 16H21v2H13.5645l-1.2227-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0052 2.0052 0 0012.2393 22h8.42l3.6543 8.5254z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H7.7683a2.0025,2.0025,0,0,1-1.9326-1.4849L2.0337,12.2576l1.9326-.5152L7.7683,26H18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PassengerDrinks.propTypes = iconPropTypes;
}
var PassengerPlus = /*#__PURE__*/React.forwardRef(function PassengerPlus(_ref119, ref) {
  var children = _ref119.children,
      _ref119$size = _ref119.size,
      size = _ref119$size === void 0 ? 16 : _ref119$size,
      rest = _objectWithoutProperties(_ref119, _excluded119);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4739 31.313L19.34 24H12.2385a4.0072 4.0072 0 01-3.8662-2.9707l-1.6338-6.126a3.8988 3.8988 0 017.5342-2.0092L15.1008 16H21v2H13.5637l-1.2226-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0051 2.0051 0 0012.2385 22h8.42l3.6543 8.5254zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H7.7676A2.0025,2.0025,0,0,1,5.835,26.5151L2.033,12.2576l1.9326-.5152L7.7676,26H18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PassengerPlus.propTypes = iconPropTypes;
}
var Password = /*#__PURE__*/React.forwardRef(function Password(_ref120, ref) {
  var children = _ref120.children,
      _ref120$size = _ref120.size,
      size = _ref120$size === void 0 ? 16 : _ref120$size,
      rest = _objectWithoutProperties(_ref120, _excluded120);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2a8.9977,8.9977,0,0,0-8.6119,11.6118L2,24v6H8L18.3881,19.6118A9,9,0,1,0,21,2Zm0,16a7.0125,7.0125,0,0,1-2.0322-.3022L17.821,17.35l-.8472.8472-3.1811,3.1812L12.4141,20,11,21.4141l1.3787,1.3786-1.5859,1.586L9.4141,23,8,24.4141l1.3787,1.3786L7.1716,28H4V24.8284l9.8023-9.8023.8472-.8474-.3473-1.1467A7,7,0,1,1,21,18Z"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "10",
    r: "2"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Password.propTypes = iconPropTypes;
}
var Paste = /*#__PURE__*/React.forwardRef(function Paste(_ref121, ref) {
  var children = _ref121.children,
      _ref121$size = _ref121.size,
      size = _ref121$size === void 0 ? 16 : _ref121$size,
      rest = _objectWithoutProperties(_ref121, _excluded121);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H17.83l2.58-2.59L19,16l-5,5,5,5,1.41-1.41L17.83,22H26v8h2V22A2,2,0,0,0,26,20Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M23.71,9.29l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2h8V28H6V4h8v6a2,2,0,0,0,2,2h6v2h2V10A1,1,0,0,0,23.71,9.29ZM16,4.41,21.59,10H16Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Paste.propTypes = iconPropTypes;
}
var Pause = /*#__PURE__*/React.forwardRef(function Pause(_ref122, ref) {
  var children = _ref122.children,
      _ref122$size = _ref122.size,
      size = _ref122$size === void 0 ? 16 : _ref122$size,
      rest = _objectWithoutProperties(_ref122, _excluded122);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
      d: "M6 4v8H4V4H6M6 3H4C3.4 3 3 3.4 3 4v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4C7 3.4 6.6 3 6 3zM12 4v8h-2V4H12M12 3h-2C9.4 3 9 3.4 9 4v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4C13 3.4 12.6 3 12 3z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V24H8V8h4m0-2H8A2 2 0 006 8V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2zM24 8V24H20V8h4m0-2H20a2 2 0 00-2 2V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Pause.propTypes = iconPropTypes;
}
var PauseFilled = /*#__PURE__*/React.forwardRef(function PauseFilled(_ref123, ref) {
  var children = _ref123.children,
      _ref123$size = _ref123.size,
      size = _ref123$size === void 0 ? 16 : _ref123$size,
      rest = _objectWithoutProperties(_ref123, _excluded123);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H10A2 2 0 008 8V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2zM22 6H20a2 2 0 00-2 2V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PauseFilled.propTypes = iconPropTypes;
}
var PauseOutline = /*#__PURE__*/React.forwardRef(function PauseOutline(_ref124, ref) {
  var children = _ref124.children,
      _ref124$size = _ref124.size,
      size = _ref124$size === void 0 ? 16 : _ref124$size,
      rest = _objectWithoutProperties(_ref124, _excluded124);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
      d: "M7 5L6 5 6 11 7 11 7 5zM10 5L9 5 9 11 10 11 10 5z"
    })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10L12 10 12 22 14 22 14 10 14 10zM20 10L18 10 18 22 20 22 20 10 20 10z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PauseOutline.propTypes = iconPropTypes;
}
var PauseOutlineFilled = /*#__PURE__*/React.forwardRef(function PauseOutlineFilled(_ref125, ref) {
  var children = _ref125.children,
      _ref125$size = _ref125.size,
      size = _ref125$size === void 0 ? 16 : _ref125$size,
      rest = _objectWithoutProperties(_ref125, _excluded125);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M7,11H6V5h1V11z M10,11H9V5h1V11z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,22H12V10h2Zm6,0H18V10h2Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  PauseOutlineFilled.propTypes = iconPropTypes;
}

export { Movement, Mp3, Mp4, Mpeg, Mpg2, Music, MusicAdd, MusicRemove, NameSpace, NavaidCivil, NavaidDme, NavaidHelipad, NavaidMilitary, NavaidMilitaryCivil, NavaidNdb, NavaidNdbDme, NavaidPrivate, NavaidSeaplane, NavaidTacan, NavaidVhfor, NavaidVor, NavaidVordme, NavaidVortac, Need, NetworkAdminControl, NetworkEnterprise, NetworkOverlay, NetworkPublic, Network_1, Network_2, Network_3, Network_3Reference, Network_4, Network_4Reference, NewTab, NextFilled, NextOutline, NoImage, NoTicket, Nominal, NonCertified, NoodleBowl, NotAvailable, NotSent, NotSentFilled, Notebook, NotebookReference, Notification, NotificationFilled, NotificationNew, NotificationOff, NotificationOffFilled, NumberSmall_0, NumberSmall_1, NumberSmall_2, NumberSmall_3, NumberSmall_4, NumberSmall_5, NumberSmall_6, NumberSmall_7, NumberSmall_8, NumberSmall_9, Number_0, Number_1, Number_2, Number_3, Number_4, Number_5, Number_6, Number_7, Number_8, Number_9, ObjectStorage, ObjectStorageAlt, ObservedHail, ObservedLightning, Omega, Opacity, OpenPanelBottom, OpenPanelFilledBottom, OpenPanelFilledLeft, OpenPanelFilledRight, OpenPanelFilledTop, OpenPanelLeft, OpenPanelRight, OpenPanelTop, OperationsField, OperationsRecord, OrderDetails, Ordinal, Outage, OutlookSevere, OverflowMenuHorizontal, OverflowMenuVertical, Overlay, Package, PageBreak, PageFirst, PageLast, PageNumber, PaintBrush, PaintBrushAlt, PalmTree, PanHorizontal, PanVertical, PanelExpansion, Paragraph, Parameter, ParentChild, PartlyCloudy, PartlyCloudyNight, Partnership, PassengerDrinks, PassengerPlus, Password, Paste, Pause, PauseFilled, PauseOutline, PauseOutlineFilled, QOperation, QOperationGauge, QOperationIf, WatsonHealthNominate, WatsonHealthPageScroll };
